import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["label", "value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["label", "value"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["label", "value"]
const _hoisted_10 = { class: "dialog-footer" }

import { ref, onMounted, reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Edit } from "@element-plus/icons-vue";
import { WarningFilled } from "@element-plus/icons-vue";
// import { Roles, useCommonStore } from "@/store/CommonStore";
import {
  GestionTareasTable,
  TareaBBDD,
  TiposTareas,
  useTareasStore,
} from "@/store/TareasStore";
import { useProyectosStore } from "@/store/ProyectosStore";
import Helper from "@/common/Helper";
import { useFasesStore } from "@/store/FaseStore";
import { User, useUserStore } from "@/store/UserStore";
import { registerMgtPeoplePickerComponent } from "@microsoft/mgt";
import { Roles } from "@/store/CommonStore";
import { TableColumnCtx } from "element-plus";
import { useProductosAcabadoStore } from "@/store/ProductosAcabadoStore";
export interface SpanMethodProps {
  row: TareaBBDD;
  column: TableColumnCtx<TareaBBDD>;
  rowIndex: number;
  columnIndex: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GestionTareasView',
  setup(__props) {

// import { computed, onMounted, ref } from "vue";
// import { ElInput, ElTable, ElTableColumn } from "element-plus";
registerMgtPeoplePickerComponent();
const router = useRouter();
const route = useRoute();
const { dateToStringFormatter } = Helper();
const FaseStore = useFasesStore();
const fases = computed(() => FaseStore.Fases);
const tiposTareas = computed(() => Object.values(TiposTareas));
const tareasDependencia = computed(() => {
  return TareasStore.GestionTareasListado;
});
const UserStore = useUserStore();
const TareasStore = useTareasStore();
const ProyectoStore = useProyectosStore();
const productosAcabadosStore = useProductosAcabadoStore();
const MostrarSwitchCompletar = (row: GestionTareasTable) => {
  if (row.Completada) return true;
  if (row.children) return false;
  if (
    (!(
      UserStore.userRoles.includes(Roles.Admin) ||
      UserStore.userRoles.includes(Roles.Manager)
    ) &&
      !row.AsignadoA) ||
    !(
      row.AsignadoA &&
      row.AsignadoA.split(";").includes(UserStore.CurrentUser.id)
    )
  )
    return true;
  return false;
};
const MostrarBotonCompletar = (row: GestionTareasTable) => {
  if (row.children) return false;
  if (row.Completada) return false;
  if (
    UserStore.userRoles.includes(Roles.Admin) ||
    UserStore.userRoles.includes(Roles.Manager)
  )
    return true;
  if (
    row.AsignadoA &&
    row.AsignadoA.split(";").includes(UserStore.CurrentUser.id)
  )
    return true;
  return false;
};

const loading = ref(false);
const dialogVisibleConfirmCompletada = ref(false);

const pickerOptions = ref({
  firstDayOfWeek: 1,
});
const formTareaEmpty: TareaBBDD = {
  Id: 0,
  IdOrigen: 0,
  IdProyecto: 0,
  IdPA: 0,
  IdMaterial: 0,
  Dependencia: "",
  Fase: 0,
  TipoTarea: "",
  Descripcion: "",
  FechaInicio: "",
  FechaCaducidad: "",
  Completada: false,
  Departamento: "",
  AsignadoA: "",
  FechaFin: "",
  TareaActiva: false,
  SAPAutoConsumo: false,
};
const formTarea = reactive<TareaBBDD>(formTareaEmpty);
const dialogTareasVisible = ref(true);
const windowHeight = window.innerHeight - 150;
const loadingTareas = ref(false);
const editarFormulario = ref(false);
const spanRowsPAs = ({ row }: SpanMethodProps) => {
  if (!row.FechaInicio && !row.FechaCaducidad && row.IdOrigen === 0) {
    return [1, 6];
  }
};
const goBack = () => {
  if (window.history.length > 2) {
    router.go(-1);
  } else {
    // Redirige a una ruta específica si no hay historial
    router.push("/");
  }
};
const EditarTarea = (row: GestionTareasTable) => {
  if (
    (UserStore.userRoles.includes(Roles.Admin) ||
      UserStore.userRoles.includes(Roles.Manager)) &&
    !row.Completada
  ) {
    editarFormulario.value = true;
  } else {
    editarFormulario.value = false;
  }
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  if (
    peoplePicker &&
    row.AsignadoA !== null &&
    String(row.AsignadoA).trim() !== ""
  ) {
    peoplePicker.selectUsersById(String(row.AsignadoA).split(";"));
  }

  const peoplePickerCompletado = document.getElementById(
    "mgtPeoplePickerCompletado"
  ) as any;
  if (
    peoplePickerCompletado &&
    row.CompletadaPor !== null &&
    String(row.CompletadaPor).trim() !== ""
  ) {
    peoplePickerCompletado.selectUsersById(
      String(row.CompletadaPor).split(";")
    );
  }
  Object.assign(formTarea, row);
  dialogTareasVisible.value = true;
};
const CancelDialog = () => {
  dialogTareasVisible.value = false;
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  peoplePicker.selectedPeople = [];
  const peoplePickerCompletado = document.getElementById(
    "mgtPeoplePickerCompletado"
  ) as any;
  peoplePickerCompletado.selectedPeople = [];
};
const ConfirmDialog = async () => {
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  const data = peoplePicker.selectedPeople;
  if (data.length > 0) {
    formTarea.AsignadoA = peoplePicker.selectedPeople
      .map((user: User) => user.id)
      .join(";");
  }
  loadingTareas.value = true;
  if (formTarea.TipoTarea !== "PA") formTarea.SAPAutoConsumo = false;
  await TareasStore.UpdateTarea(formTarea);
  await TareasStore.GetByIdProyecto(Number(route.params.Pid));
  loadingTareas.value = false;
  dialogTareasVisible.value = false;
};
const handleSubmit = (event: Event) => {
  event.preventDefault();
};

const completarTarea = async (tarea: TareaBBDD) => {
  const tareaUpdate = TareasStore.GestionTareasListado.find(
    (t) => t.Id === tarea.Id
  );
  if (tareaUpdate) {
    loading.value = true;
    tareaUpdate.FechaFin = new Date().toISOString();
    tareaUpdate.Completada = true;
    tareaUpdate.CompletadaPor = UserStore.CurrentUser.id;
    await TareasStore.UpdateTarea(tareaUpdate);
    await TareasStore.GetByIdProyecto(tareaUpdate.IdProyecto);
    // Si la tarea tiene SAP AUtoconsumo marcado, se lanza a SAP
    if (tareaUpdate.SAPAutoConsumo) {
       // Llamar a SAP para recuperar el coste estandar y actualizarlo
    const pa = await productosAcabadosStore.GetProductosAcabadosByIds([tareaUpdate.IdPA]);
    if (pa && pa.data && pa.data.length > 0) {
      await productosAcabadosStore
        .GetSAPDataByReference(pa.data[0].Codigo)
        .then((response) => {
          if (response) {
            pa.data[0].CosteEstandarUMB = Number(parseFloat(response).toFixed(2));
            productosAcabadosStore.UpdateProductoAcabado(pa.data[0]);
          }
        })
        .catch((error: Error) => {
          console.error("Error al obtener datos de SAP:", error);
        });
    }
      TareasStore.SAPAutoconsumo(tareaUpdate);
    }
    await TareasStore.NotificarTareas(
      ProyectoStore.ProyectoSelected,
      null,
      null,
      tareaUpdate
    );
    await TareasStore.GetAllTareasPendientes(tareaUpdate.IdProyecto);
  }
  dialogVisibleConfirmCompletada.value = false;
  loading.value = false;
};

onMounted(async () => {
  dialogTareasVisible.value = false;
  loadingTareas.value = true;
  await TareasStore.GetByIdProyecto(Number(route.params.Pid));
  loadingTareas.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_mgt_person = _resolveComponent("mgt-person")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mgt_people_picker = _resolveComponent("mgt-people-picker")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_page_header, { onBack: goBack }, {
        title: _withCtx(() => [
          _createTextVNode(" Tareas del proyecto " + _toDisplayString(_unref(ProyectoStore).ProyectoSelected.Descripcion), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_table, {
              class: "main-table",
              ref: "tableTareas",
              data: 
              _unref(TareasStore).GestionTareas.sort((a, b) =>
                b.TipoTarea.localeCompare(a.TipoTarea)
              )
            ,
              style: {"width":"100%"},
              "empty-text": "No hay datos",
              height: windowHeight - 50,
              size: "small",
              stripe: "",
              "scrollbar-always-on": "",
              "row-key": "Id",
              "default-expand-all": "",
              "span-method": spanRowsPAs,
              loading: loadingTareas.value
            }, {
              default: _withCtx(() => [
                _cache[14] || (_cache[14] = _createTextVNode(" > ")),
                _createVNode(_component_el_table_column, {
                  prop: "Descripcion",
                  label: "Descripcion",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Fase",
                  prop: "FaseText",
                  width: "200",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Departamento",
                  prop: "Departamento",
                  width: "200",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Asignado a",
                  width: "300"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_1, [
                      (!row.AsignadoA || row.AsignadoA.trim().length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.AsignadoA.split(';'), (p) => {
                              return (_openBlock(), _createBlock(_component_mgt_person, {
                                key: p,
                                "user-id": p,
                                view: "oneline",
                                "person-card": "hover",
                                "fetch-image": ""
                              }, null, 8, ["user-id"]))
                            }), 128))
                          ]))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "FechaInicio",
                  label: "Fecha inicio",
                  formatter: _unref(dateToStringFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  property: "FechaFin",
                  label: "Fecha fin",
                  formatter: _unref(dateToStringFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  property: "FechaCaducidad",
                  label: "Fecha caducidad",
                  formatter: _unref(dateToStringFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Completada",
                  prop: "Completada",
                  width: "120",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    (MostrarSwitchCompletar(row))
                      ? (_openBlock(), _createBlock(_component_el_switch, {
                          key: 0,
                          modelValue: row.Completada,
                          "onUpdate:modelValue": ($event: any) => ((row.Completada) = $event),
                          disabled: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (MostrarBotonCompletar(row))
                        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                            key: 1,
                            width: "220",
                            icon: _unref(WarningFilled),
                            "icon-color": "#E00D0D",
                            title: "¿Seguro que deseas completar la tarea?",
                            onConfirm: ($event: any) => (completarTarea(row))
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "danger",
                                round: ""
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode(" Completar ")
                                ])),
                                _: 1,
                                __: [10]
                              })
                            ]),
                            actions: _withCtx(({ confirm, cancel }) => [
                              _createVNode(_component_el_button, {
                                round: "",
                                size: "small",
                                onClick: cancel
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("No")
                                ])),
                                _: 2,
                                __: [11]
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_button, {
                                round: "",
                                type: "danger",
                                size: "small",
                                onClick: confirm
                              }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createTextVNode("Si")
                                ])),
                                _: 2,
                                __: [12]
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["icon", "onConfirm"]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    (!row.children)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          icon: _unref(Edit),
                          round: "",
                          onClick: ($event: any) => (EditarTarea(row))
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("Detalles")
                          ])),
                          _: 2,
                          __: [13]
                        }, 1032, ["icon", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1,
              __: [14]
            }, 8, ["data", "height", "loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogTareasVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogTareasVisible).value = $event)),
      title: "Editar tarea",
      width: "600"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            round: "",
            class: "buttonIdilia-light",
            onClick: CancelDialog
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("Cancelar")
            ])),
            _: 1,
            __: [16]
          }),
          (!formTarea.Completada)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                round: "",
                class: "buttonIdilia",
                onClick: ConfirmDialog
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Guardar")
                ])),
                _: 1,
                __: [17]
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "30%",
          "label-position": "left",
          model: formTarea,
          disabled: !editarFormulario.value,
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Descripción",
              prop: "Descripcion",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formTarea.Descripcion,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formTarea.Descripcion) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Departamento",
              prop: "Departamento"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formTarea.Departamento,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formTarea.Departamento) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Fase",
              prop: "Fase"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  disabled: !editarFormulario.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formTarea.Fase) = $event)),
                  placeholder: "Selecciona Fase",
                  class: "el-select el-select__wrapper"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fases.value, (fase) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: fase.Id,
                      label: fase.Descripcion,
                      value: fase.Id
                    }, null, 8, _hoisted_5))
                  }), 128))
                ], 8, _hoisted_4), [
                  [_vModelSelect, formTarea.Fase]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Tipo tarea",
              prop: "TipoTarea"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  disabled: !editarFormulario.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formTarea.TipoTarea) = $event)),
                  placeholder: "Selecciona tipo",
                  class: "el-select el-select__wrapper"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposTareas.value, (tipo) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tipo,
                      label: tipo,
                      value: tipo
                    }, null, 8, _hoisted_7))
                  }), 128))
                ], 8, _hoisted_6), [
                  [_vModelSelect, formTarea.TipoTarea]
                ])
              ]),
              _: 1
            }),
            (formTarea.TipoTarea === 'PA')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "SAP Autoconsumo",
                  prop: "SAPAutoConsumo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: formTarea.SAPAutoConsumo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formTarea.SAPAutoConsumo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "Dependencia",
              prop: "Dependencia"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  disabled: !editarFormulario.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formTarea.Dependencia) = $event)),
                  placeholder: "Selecciona",
                  class: "el-select el-select__wrapper"
                }, [
                  _cache[15] || (_cache[15] = _createElementVNode("option", {
                    label: " 0 - Sin dependecia",
                    value: 0
                  }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tareasDependencia.value, (tarea) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tarea.IdOrigen,
                      label: tarea.Descripcion,
                      value: tarea.IdOrigen
                    }, null, 8, _hoisted_9))
                  }), 128))
                ], 8, _hoisted_8), [
                  [_vModelSelect, formTarea.Dependencia]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Asignado a" }, {
              default: _withCtx(() => [
                _createVNode(_component_mgt_people_picker, {
                  ref: "mgtPeoplePicker",
                  id: "mgtPeoplePicker",
                  type: "person",
                  class: "people-picker",
                  disabled: !editarFormulario.value
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Fecha inicio",
              prop: "FechaInicio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: formTarea.FechaInicio,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formTarea.FechaInicio) = $event)),
                  "picker-options": pickerOptions.value,
                  type: "date",
                  format: "DD/MM/YYYY",
                  placeholder: "Seleccionar fecha"
                }, null, 8, ["modelValue", "picker-options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Fecha caducidad",
              prop: "FechaCaducidad"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: formTarea.FechaCaducidad,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formTarea.FechaCaducidad) = $event)),
                  "picker-options": pickerOptions.value,
                  type: "date",
                  format: "DD/MM/YYYY",
                  placeholder: "Seleccionar fecha"
                }, null, 8, ["modelValue", "picker-options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Fecha fin",
              prop: "FechaFin"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  disabled: "",
                  modelValue: formTarea.FechaFin,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formTarea.FechaFin) = $event)),
                  "picker-options": pickerOptions.value,
                  type: "date",
                  format: "DD/MM/YYYY",
                  placeholder: ""
                }, null, 8, ["modelValue", "picker-options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Completada por" }, {
              default: _withCtx(() => [
                _createVNode(_component_mgt_people_picker, {
                  ref: "mgtPeoplePickerCompletado",
                  id: "mgtPeoplePickerCompletado",
                  class: "people-picker",
                  disabled: ""
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})